import React, { useState, useRef, useCallback } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import styles from './DropDownFilter.module.scss';
import useOnClickOutside from '../../../hooks/useOnClickOutside';

function DropDownFilter(props) {
  const { values, images } = props;

  const [index, setIndex] = useState(props.currentIndex > values.length ? 0 : props.currentIndex);
  const [drop, setDrop] = useState(false);

  const ref = useRef();
  useOnClickOutside(
    ref,
    useCallback(() => setDrop(false), []),
  );

  const current = values[index];

  const handleDrop = () => {
    setDrop(!drop);
  };

  const handleSwitchItem = (index) => {
    const value = values[index].value;
    props.onChange(value);

    setIndex(index);
  };

  if (!values || !values.length) {
    return null;
  }

  return (
    <div className={cn(styles.toolbar_right, images ? styles.withImages : '')} ref={ref}>
      <div onClick={handleDrop} className={cn(styles.drop_down, 'drop_down', drop ? null : styles.passive)}>
        <div className={cn(styles.target, 'target')}>
          {images ? <img src={current.label} alt="" /> : <span>{props.staticPoint ? 'Sort by' : current.label}</span>}
          <span className={cn(styles['ic-dropup'], 'ic-dropup')} />
        </div>

        <div className={cn(styles.items, 'items')}>
          <div className={cn(styles.wrapper_items, 'wrapper_items')}>
            {values.map((item, i) => {
              return (
                <div
                  key={item.value}
                  onClick={() => handleSwitchItem(i)}
                  className={index === i ? cn(styles.active, 'active') : ''}
                >
                  {images ? <img src={item.label} alt="" /> : item.label}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

export default DropDownFilter;

DropDownFilter.defaultProps = {
  currentIndex: 0,
  images: false,
  staticPoint: false,
};

DropDownFilter.propTypes = {
  currentIndex: PropTypes.number,
  images: PropTypes.bool,
  values: PropTypes.arrayOf(PropTypes.object).isRequired,
  onChange: PropTypes.func.isRequired,
  staticPoint: PropTypes.bool,
};
